<!--
 * @Author: your name
 * @Date: 2020-11-20 11:12:14
 * @LastEditTime: 2021-07-14 18:24:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/NotCommonNavigatorDialog/index.vue
-->
<style scoped lang="sass">

.t_c
  text-align: center

.not_common_navigator_content
  height: 100%
  display: flex
  flex-direction: column
  justify-content: space-between
  padding-bottom: 20PX

.title
  line-height: 20PX
  font-size: 17PX
  padding: 0 25PX

.details
  margin-top: 30PX
  margin-bottom: 20PX
  line-height: 17PX
  font-size: 17PX
  padding: 0 25PX

.url
  padding: 0 25PX
  font-size: 14PX
  color: var(--menu-primary-background-colour)

.img_box
  height: 70PX
  text-align: center
  margin-bottom: 20PX

.img
  height: 100%

.copy_button
  margin-top: 12px
  background-color: var(--menu-primary-background-colour)

.hidden
    display: none
</style>

<template lang="pug">
.not_common_navigator_content
  .img_box
    img.img(:src="imgSrc")
  .title.t_c.b For a better experience, we recommend using a different browser:
  .details.t_c.o75 Copy the menu address by pressing the COPY MENU button and paste it in Safari, Chrome, Firefox or Opera.
  .url.t_c.b.hidden {{ venueUrl }}
  van-button.copy_button(
    size="large"
    type="primary"
    @click="copyUrl($event)"
  ) COPY MENU
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import clip from '@/utils/clipboard'
import { Toast } from 'vant'

@Component({
  props: {
    venueUrl: {
      type: String
    }
  }
})
class NotCommonNavigatorContent extends Vue {
  imgSrc = require('@/assets/not-common-browser.png')

  copyUrl(event) {
    clip(this.venueUrl, event)
    Toast('Copied successfully')
  }
}

export default NotCommonNavigatorContent
</script>
